import React, { useState, useEffect } from 'react';
import Styled from 'styled-components';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Applet, { AppletContainer } from '../../Components/Applet';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import GridContainer from '../../Components/Grid';
import usePost from '../../Hooks/usePost';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useProfile } from '../../Contexts/UserProfileContext';
import { StyledButton } from '../../Components/Generics.styled';

const LoginContainer = Styled.div`
width: 100%;
height: 100%;

`;
const LoginButton = Styled(Button)`
background: #2e69fe 0% 0% no-repeat padding-box !important;
box-shadow: 0px 3px 3px #00000061;
border-radius: 4px;
opacity: 1;
width: 100%;
`;
const FormName = Styled.div`
text-align: left;
letter-spacing: 0.77px;
color: #000000DE;
opacity: 1;
padding-left: 15px;
padding-top: 11px;
`;

const LoginTextFieldContainer = Styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  align-items: center;
 
`;

const WelcomeText = Styled.div`
width: 350px;
font-size: 23px;
margin-left: auto;
margin-right: auto;
margin-bottom: 30px;
text-align: center;
letter-spacing: 0px;
opacity: 1;
`;

const AccountManagement = () => {
    const { profile } = useProfile() || {};
    const { userName } = { ...profile };

    const { post } = usePost('/forgotPasswordResetPassword');
    const { post: postSendVerificationLink } = usePost('/sendEmailVerificationLink');
    const { post: postVerifyEmailCode } = usePost('/verifyEmailCode');
    const param = window.location.href?.split('/')[4];
    const mode = param.split('?')[0];
    const code = param.split('code=')[1];

    const [newPassword, setNewPassword] = useState({ value: '', showPassword: false });
    const [email, setEmail] = useState('');
    const [postData, setPostData] = useState({
        error: false,
        success: false,
        isLoading: false,
        message: [''],
    });

    const [emailVerify, setEmailVerify] = useState({ text: '', btnDisabled: false });

    const resetPassword = async () => {
        try {
            setPostData({
                error: false,
                success: false,
                isLoading: true,
                message: [''],
            });
            const resetPasswordResp = await post(
                { userName: email, code, password: newPassword.value },
                'POST'
            );
            if (resetPasswordResp.data.result === true) {
                setPostData({
                    error: false,
                    success: true,
                    isLoading: false,
                    message: ['Password has been succesfully reset. Please log in.'],
                });
            } else if (resetPasswordResp.data.result === false) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: resetPasswordResp.data.errors,
                });
            }
        } catch (err) {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Something went wrong. Please try again later.'],
            });
        }
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const sendEmailVerificationLink = async () => {
        try {
            await postSendVerificationLink(
                {
                    userName: profile.userName,
                    baseUrl: process.env.REACT_APP_API_ACCOUNT_MANAGEMENT_VERIFY_EMAIL,
                },
                'POST'
            );

            setEmailVerify({ btnDisabled: true, text: 'Verification email sent.' });
        } catch (err) {
            setPostData({
                ...postData,
                message: ['Something went wrong...'],
                isLoading: false,
                success: false,
                error: true,
            });
        }
    };

    const verifyEmail = async () => {
        try {
            const verifyEmailResp = await postVerifyEmailCode(
                {
                    userName: profile.userName,
                    code,
                },
                'POST'
            );
            if (verifyEmailResp.data.result === true) {
                setPostData({
                    ...postData,
                    message: ['Email has been verified!'],
                    isLoading: false,
                    success: true,
                    error: false,
                });
                window.location.reload();
            } else {
                setPostData({
                    ...postData,
                    message: ['Email has not been verified.'],
                    isLoading: false,
                    success: false,
                    error: true,
                });
            }
        } catch (err) {
            setPostData({
                ...postData,
                message: ['Something went wrong...'],
                isLoading: false,
                success: false,
                error: true,
            });
        }
    };

    const resetVerifyEmail = () => {
        setEmailVerify({
            text: '',
            btnDisabled: false,
        });
    };

    useEffect(() => {
        setTimeout(resetVerifyEmail, 10000);
    }, [emailVerify.btnDisabled]);

    useEffect(() => {
        if (mode === 'verifyEmail' && profile.userName) {
            verifyEmail();
        }
    }, [userName, mode]);

    return (
        <LoginContainer>
            <WelcomeToDavie />
            <AppletContainer>
                <WelcomeText>Account Managment</WelcomeText>
                <Applet height="150px">
                    {mode === 'sendVerificationEmail' ? (
                        <div>
                            <LoginTextFieldContainer>
                                <StyledButton
                                    disabled={emailVerify.btnDisabled}
                                    onClick={() => sendEmailVerificationLink()}
                                    variant="contained"
                                    color="primary"
                                >
                                    Send Verification Email
                                </StyledButton>
                                <div style={{ marginTop: '16px', color: 'green' }}>
                                    {emailVerify.text}
                                </div>
                            </LoginTextFieldContainer>
                            <FormName>Check your inbox to verify your account.</FormName>
                        </div>
                    ) : null}

                    {mode === 'verifyEmail' ? (
                        <div>
                            <FormName>Email Verification</FormName>
                        </div>
                    ) : null}
                    {mode === 'resetPassword' ? (
                        <div>
                            <FormName>Enter your email and new password.</FormName>

                            <LoginTextFieldContainer>
                                <TextField
                                    error={email === ''}
                                    id="email"
                                    label="Email"
                                    defaultValue={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    helperText={email === '' ? 'Email cannot be empty' : ''}
                                    variant="outlined"
                                    required
                                />
                                <br />
                                <TextField
                                    error={newPassword === ''}
                                    id="new-password"
                                    label="New Password"
                                    defaultValue={newPassword.value}
                                    onChange={(e) =>
                                        setNewPassword({
                                            ...newPassword,
                                            value: e.target.value,
                                        })
                                    }
                                    type={newPassword.showPassword ? 'text' : 'password'}
                                    helperText={
                                        newPassword === '' ? 'Password cannot be empty' : ''
                                    }
                                    variant="outlined"
                                    required
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <StyledButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() =>
                                                        setNewPassword({
                                                            ...newPassword,
                                                            showPassword: !newPassword.showPassword,
                                                        })
                                                    }
                                                    onMouseDown={(e) => handleMouseDownPassword(e)}
                                                >
                                                    {newPassword.showPassword ? (
                                                        <Visibility />
                                                    ) : (
                                                        <VisibilityOff />
                                                    )}
                                                </StyledButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <br />

                                <StyledButton
                                    onClick={() => resetPassword()}
                                    variant="contained"
                                    color="primary"
                                    disabled={newPassword === ''}
                                >
                                    Reset Password
                                </StyledButton>
                            </LoginTextFieldContainer>
                        </div>
                    ) : (
                        <div />
                    )}
                    {
                        <div
                            style={{
                                marginTop: '8px',
                                marginLeft: '16px',
                                marginBottom: '8px',
                                color: postData.error ? 'red' : 'green',
                                fontSize: '13px',
                            }}
                        >
                            {postData.message && postData.message.length >= 1
                                ? postData.message.map((item, idx) => <div key={idx}>{item}</div>)
                                : postData.message}
                        </div>
                    }
                </Applet>
            </AppletContainer>
        </LoginContainer>
    );
};

export default AccountManagement;
